/**
 * Normalizes cart vs payment abandoned-lead money fields for admin UI.
 * Cart: cartValue is product-only when cartValueExcludesShipping === true; legacy rows treat cartValue as incl. shipping.
 * Payment: cartValue is grand total incl. shipping (unchanged).
 */
export function getAbandonedLeadDisplayAmounts(lead = {}) {
  const cv = Number(lead.cartValue) || 0;
  const lmd = Number(lead.totalLMDCharges) || 0;
  const stage = lead.stage;

  if (stage === "cart") {
    const ex = lead.cartValueExcludesShipping === true;
    const productSubtotal = ex ? cv : Math.max(0, cv - lmd);
    const grandEstimated = ex ? cv + lmd : cv;
    return { productSubtotal, lmd, grandEstimated, listColumnValue: productSubtotal };
  }

  return {
    productSubtotal: Math.max(0, cv - lmd),
    lmd,
    grandEstimated: cv,
    listColumnValue: cv,
  };
}
